module.exports = __webpack_public_path__ + "media/images/icons/search-location-b2a398246e236ccf02aa6508a904a6fe.svg";